<template>
  <div class="v-data-table theme--light">
    <div class="v-data-table__wrapper">
      <table style="width: 100%;">
        <tbody>
        <tr :key="key" v-for="(item, key) in rows">
          <td>{{ item['text'] }}</td>
          <td>
            <slot :name="`value.${item.value}`">{{ data[item['value']] }}</slot>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Table from "@/components/katm/table";

export default {
  name: 'ColumnTable',
  components: {Table},
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>